import { useState, useEffect } from 'react'

// Check if we're on mobile during SSR/initial render
const getInitialMobile = () => {
  if (typeof window === 'undefined') return false
  return window.innerWidth < 768
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(getInitialMobile)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return isMobile
}
